import { useQuery } from '@tanstack/react-query';
import { getLogRepositoryQuery } from '../apis';

const useGetLogRepository = ({ lastRunId }) => {
  const query = useQuery({
    queryKey: ['logs-repository', lastRunId],
    enabled: !!lastRunId,
    queryFn: () =>
      getLogRepositoryQuery({
        lastRunId,
      }),
    staleTime: 0,
  });

  return query;
};

export default useGetLogRepository;
